module.exports = __webpack_public_path__ + "img/drag-to-answer-white.224806ba.png";